import { initialGloveImagesState, initialPersonalState, unselectedColorState, unselectedState } from 'src/constants'
import { BaseInitialState, State } from 'src/types'
import { initialYouthState } from '../../japan/slice/youth'

export const unselectedStateEn = { label: 'Unselected', value: 'unselected' }
export const unselectedColorStateEn = { label: 'Unselected', value: 'unselected', color: '#fff' }

export const baseInitialStateEn: BaseInitialState = {
  // トップページのloading
  isLoading: false,
  backStyle: unselectedStateEn,
  dominantArm: unselectedStateEn,
  size: unselectedStateEn,
  fingerGuardType: unselectedStateEn,
  baseModel: {
    productNumber: '',
    imageUrl: '',
    dominantArm: 'unselected',
    position: 'infielder', // 本当はここ、infielderでありたくない
    size: 0,
    webParts: '',
    description: '',
    series: '',
    backStyle: '',
    imageWidth: 0,
    imageHeight: 0
  }
}

export const colorInitialStateEn = {
  parts: { label: 'Over All', value: 'all' },
  all: unselectedColorStateEn,
  catchFace: unselectedColorStateEn,
  edge: unselectedColorStateEn,
  lace: unselectedColorStateEn,
  linings: unselectedColorStateEn,
  hamidashi: unselectedColorStateEn,
  listLiningsMaterial: unselectedColorStateEn,
  stitch: { label: 'Unselected', value: 'unselected', color: '#eee' },
  web: unselectedColorStateEn,
  web2: unselectedColorStateEn,
  thumbHook: unselectedColorStateEn,
  littleHook: unselectedColorStateEn,
  listBelt: unselectedColorStateEn,
  indexCover: unselectedColorStateEn
}

// 全ポジションで使うカラー情報
export const colorInitialState = {
  parts: { label: '全体', value: 'all' },
  all: unselectedColorState,
  catchFace: unselectedColorState,
  edge: unselectedColorState,
  lace: unselectedColorState,
  linings: unselectedColorState,
  hamidashi: unselectedColorState,
  stitch: unselectedColorState,
  web: unselectedColorState,
  web2: unselectedColorState,
  thumbHook: unselectedColorState,
  littleHook: unselectedColorState,
  listBelt: unselectedColorState,
  indexCover: unselectedColorState,
  mouton: unselectedColorState,
  atomsLabel: unselectedState
}

export const gloveColorInitialStateEn = {
  thumbOut: unselectedColorStateEn,
  thumbWeb: unselectedColorStateEn,
  thumbRoot: unselectedColorStateEn,
  thumbWebAndIndexWeb: unselectedColorStateEn,
  thumbIndexMiddle: unselectedColorStateEn,
  indexWeb: unselectedColorStateEn,
  indexMiddle: unselectedColorStateEn,
  indexLeftMiddleRight: unselectedColorStateEn,
  middleIndex: unselectedColorStateEn,
  middleLeftRingRight: unselectedColorStateEn,
  middleRing: unselectedColorStateEn,
  ringMiddle: unselectedColorStateEn,
  ringLeftLittleRight: unselectedColorStateEn,
  ringLittle: unselectedColorStateEn,
  littleRing: unselectedColorStateEn,
  littleOut: unselectedColorStateEn
}

export const initialEmbroideryState = {
  id: 0,
  typeFace: { label: '', value: '' },
  position: { label: '', value: '' },
  color: { label: '', value: '', color: '' },
  shadowColor: { label: '', value: 'none' },
  edgeColor: { label: '', value: 'none' },
  content: ''
}

export const initialStateCatcherMittEn: State = {
  ...baseInitialStateEn,
  ...colorInitialStateEn,
  tanner: unselectedStateEn,
  backStyle: unselectedStateEn,
  thumb: unselectedColorStateEn,
  webParts: unselectedStateEn,
  printLeatherType: unselectedStateEn,
  thumbIndexMiddleRight: unselectedColorStateEn,
  catchFaceTarget: unselectedColorStateEn,
  indexAndMiddle: unselectedColorStateEn,
  middleRing: unselectedColorStateEn,
  middleLeftRingLittle: unselectedColorStateEn,
  middleLeftRing: unselectedColorStateEn,
  littleRing: unselectedColorStateEn,
  littleOut: unselectedColorStateEn,
  fingerStand: unselectedColorStateEn,
  indexFingerTipOut: unselectedColorStateEn,
  mouton: unselectedColorStateEn,
  atomsLabel: unselectedColorStateEn,
  embroideries: [initialEmbroideryState],
  personal: initialPersonalState,
  figurePanelNum: 1,
  images: initialGloveImagesState
}

export const initialStateFirstMittEn: State = {
  ...baseInitialStateEn,
  ...colorInitialStateEn,
  tanner: unselectedStateEn,
  loopOfRingFinger: unselectedStateEn,
  loopOfRingFingerColor: unselectedColorStateEn,
  webParts: unselectedStateEn,
  printLeatherType: unselectedStateEn,
  thumb: unselectedColorStateEn,
  underWeb: unselectedColorStateEn,
  boomerang: unselectedColorStateEn,
  mouton: unselectedStateEn,
  atomsLabel: unselectedStateEn,
  embroideries: [initialEmbroideryState],
  personal: initialPersonalState,
  figurePanelNum: 1,
  images: initialGloveImagesState
}

export const initialYouthStateEn = initialYouthState // USA版は無いため、jaのobjectを流用
